import React from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV_LINKS, SITE } from "@/constants/site";

export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  return (
    <footer
      style={{
        backgroundColor: "var(--rk-dark)",
        color: "var(--rk-cream)",
      }}
    >
      <div className="rk-container-wide" style={{ paddingTop: 80, paddingBottom: 56 }}>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div
              style={{
                fontFamily: "var(--font-heading)",
                fontSize: "clamp(32px, 4vw, 48px)",
                lineHeight: 1.05,
                letterSpacing: "-0.01em",
              }}
            >
              Rakia Finley
            </div>
            <p
              className="mt-5"
              style={{
                color: "rgba(250,247,242,0.7)",
                maxWidth: 460,
                fontSize: 16,
                lineHeight: 1.55,
              }}
            >
              Fractional CTO/CIO. Founder, {SITE.firmName}. Twenty years of
              building things that hold.
            </p>
          </div>
          <div className="md:col-span-3">
            <div
              className="rk-eyebrow"
              style={{ color: "rgba(250,247,242,0.55)", marginBottom: 18 }}
            >
              Navigate
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.key}>
                  <Link
                    to={l.to}
                    style={{
                      color: "var(--rk-cream)",
                      textDecoration: "none",
                      fontSize: 15,
                    }}
                    className="hover:underline decoration-[color:var(--rk-copper)] underline-offset-4"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <div
              className="rk-eyebrow"
              style={{ color: "rgba(250,247,242,0.55)", marginBottom: 18 }}
            >
              Direct
            </div>
            <ul className="space-y-3" style={{ fontSize: 15 }}>
              <li>
                <Link
                  to="/contact"
                  style={{ color: "var(--rk-cream)", textDecoration: "none" }}
                  className="hover:underline decoration-[color:var(--rk-copper)] underline-offset-4"
                >
                  Use the contact form
                </Link>
              </li>
              <li style={{ color: "rgba(250,247,242,0.7)" }}>{SITE.location}</li>
              <li>
                <a
                  href={SITE.firmUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "var(--rk-cream)", textDecoration: "none" }}
                  className="hover:underline decoration-[color:var(--rk-copper)] underline-offset-4"
                >
                  coppervine.io
                </a>
              </li>
              {SITE.linkedin && (
                <li>
                  <a
                    href={SITE.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "var(--rk-cream)", textDecoration: "none" }}
                    className="hover:underline decoration-[color:var(--rk-copper)] underline-offset-4"
                  >
                    LinkedIn
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div
          className="mt-14 pt-6 flex flex-col md:flex-row justify-between gap-3"
          style={{ borderTop: "1px solid rgba(181,114,42,0.4)" }}
        >
          <span className="rk-caption" style={{ color: "rgba(250,247,242,0.55)" }}>
            © {new Date().getFullYear()} Rakia Finley. A {SITE.firmName} principal.
          </span>
          <span className="rk-caption" style={{ color: "rgba(250,247,242,0.55)" }}>
            Composed in DC.
          </span>
        </div>
      </div>
    </footer>
  );
}
